import React, { Component, FormEvent } from 'react';

import { FatalAttraction as FA } from '@vpr/tracking';

import { translate } from '@vimeo/i18n-runtime';
import { Button } from '@vimeo/iris/components';
import { ChevronRight } from '@vimeo/iris/icons';
import { themes } from '@vimeo/iris/themes';

import {
  ChevronLeft,
  NextButtonWrapper,
  NoWrapHeader,
  PageControlFooter,
  PageControls,
  PageNumberInput,
} from './Styles';
import { AlbumLayouts, AlbumThemes } from '../../types';

interface Props {
  theme: AlbumThemes;
  currentPage?: number;
  pageSize?: number;
  totalItems: number;
  onSetPage: (n: number) => void;
  layout?: AlbumLayouts;
}

interface State {
  pageNumber: number | null;
}

class PaginationFooter extends Component<Props, State> {
  public readonly state: State = {
    pageNumber: this.props.currentPage || 1,
  };

  public onInput = (e: FormEvent<HTMLInputElement>) => {
    e.preventDefault();
    const { pageSize = 12, totalItems } = this.props;
    const lastPage = Math.ceil(totalItems / pageSize);
    const value = parseInt(e.currentTarget.value, 10);

    if (value > 0 && value <= lastPage && value !== this.state.pageNumber) {
      this.setState({ pageNumber: value });
    } else if (isNaN(value)) {
      this.setState({
        pageNumber: null,
      });
    }
  };

  public onSet = (page: number) => {
    const { onSetPage } = this.props;

    if (this.state.pageNumber !== page) {
      this.setState({ pageNumber: page });
    }
    this.scrollToTop();
    onSetPage(page);
  };

  public onPressEnter = (e: FormEvent<HTMLInputElement>) => {
    const { onSetPage } = this.props;

    // @ts-ignore
    // does not recognize property key
    if (e.key === 'Enter' && !isNaN(this.state.pageNumber) && this.state.pageNumber) {
      this.scrollToTop();
      onSetPage(this.state.pageNumber);
    }
  };

  public scrollToTop = () => {
    const { layout } = this.props;

    if (layout === 'live') {
      const topOfGrid = window.innerWidth > 767 ? window.innerHeight * 0.8 - 50 : 460;
      window.scroll(0, topOfGrid);
    } else {
      window.scrollTo(0, 0);
    }
  };

  render() {
    const { theme = 'standard', currentPage = 1, pageSize = 12, totalItems } = this.props;
    const lastPage = Math.ceil(totalItems / pageSize);

    return (
      <div>
        {lastPage > 1 && (
          <PageControlFooter>
            <NextButtonWrapper>
              <Button
                format="secondary"
                theme={theme === 'standard' ? themes.light : themes.dark}
                disabled={currentPage === lastPage}
                onClick={() => {
                  this.onSet(currentPage + 1);
                  FA.trackClick({
                    container: 'showcase',
                    component: 'pages',
                    keyword: 'next_footer',
                  });
                }}
              >
                {translate('Next')}
              </Button>
            </NextButtonWrapper>

            <PageControls>
              <Button
                size="md"
                format="secondary"
                theme={theme === 'standard' ? themes.light : themes.dark}
                icon={<ChevronLeft />}
                disabled={currentPage === 1}
                onClick={() => {
                  this.onSet(currentPage - 1);
                  FA.trackClick({
                    container: 'showcase',
                    component: 'pages',
                    keyword: 'previous',
                  });
                }}
              />
              <PageNumberInput
                id="page-number"
                name="page-number"
                label={false}
                value={this.state.pageNumber ? this.state.pageNumber : ''}
                onChange={this.onInput}
                onKeyDown={this.onPressEnter}
                style={{
                  width: this.state.pageNumber
                    ? 25 + this.state.pageNumber.toString().length * 8
                    : 40,
                }}
              />
              <Button
                size="md"
                format="secondary"
                theme={theme === 'standard' ? themes.light : themes.dark}
                icon={<ChevronRight />}
                disabled={currentPage === lastPage}
                onClick={() => {
                  this.onSet(currentPage + 1);
                  FA.trackClick({
                    container: 'showcase',
                    component: 'pages',
                    keyword: 'next',
                  });
                }}
              />
              <NoWrapHeader style={{ margin: 0 }}>
                <span>of {lastPage}</span>
              </NoWrapHeader>
            </PageControls>
          </PageControlFooter>
        )}
      </div>
    );
  }
}

export default PaginationFooter;
